import React from "react";

import Main from "./container/Main/Main";

const app = () => {
  return <Main />;
};

export default app;
